// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div style="position: relative; min-width: 450px;">
    <v-row>
      <v-text-field prepend-icon="mdi-magnify" :label="$t('Please enter your registration number...')"
                    v-model="searchText" @keyup.native.enter="sourceClicked(searchText)"
                    @keyup.native.esc="resetSearch()" hide-details single-line></v-text-field>
      <v-btn class="d-none d-sm-flex" outlined small @click="sourceClicked(searchText)">
        <v-progress-circular v-if="searchLoader"
                             :size="18"
                             color="#FFFFFF"
                             indeterminate
        ></v-progress-circular>
        <span v-if="!searchLoader">Search</span>
      </v-btn>
    </v-row>
    <v-list dense v-if="showList" two-line :style="listStyle" class="get-click">
      <v-list-item v-for="source in autoCompleteChoices" :key="source.short_name" @click="sourceClicked(source)">
        <v-list-item-action>
          <img :src="iconForSkySource(source)"/>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ nameForSkySource(source) }}</v-list-item-title>
          <v-list-item-subtitle>{{ typeToName(source.types[0]) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import Vue from 'vue'
import swh from '@/assets/sw_helpers.js'
import vClickOutside from 'v-click-outside'
import _ from 'lodash'

export default {
  data: function () {
    return {
      autoCompleteChoices: [],
      searchText: '',
      lastQuery: undefined,
      selectedStar: undefined,
      searchLoader: false
    }
  },
  props: ['value', 'floatingList'],
  watch: {
    searchText: function () {
      if (this.searchText === '') {
        this.autoCompleteChoices = []
        this.lastQuery = undefined
        return
      }
      this.refresh()
    }
  },
  computed: {
    listStyle: function () {
      return this.floatingList ? 'position: absolute; z-index: 1000; margin-top: 8px' : ''
    },
    showList: function () {
      return this.searchText !== ''
    }
  },
  methods: {
    async getStar (regKey) {
      var that = this

      await fetch(process.env.VUE_APP_YOUENVENT_API_SERVER + '/skysources/registry?name=' + regKey)
        .then((response) => {
          console.log(response)
          if (!response.ok) {
            this.$store.commit('setRegistryError', true)
            throw new Error(response.statusText)
          }
          return response.json()
        })
        .then(function (jsonObj) {
          that.selectedStar = jsonObj
        })
        .catch(err => {
          this.searchLoader = false
          console.log(err.response)
        })

      if (this.$store.state.registryError) {
        this.searchLoader = false
        throw new Error('Not Found')
      }
      return swh.lookupGalaxieRegisterByName(this.selectedStar.starName)
    },
    sourceClicked: function (val) {
      this.searchLoader = true
      var that = this
      this.getStar(val).then(res => {
        Vue.set(res, 'register', this.selectedStar)
        Vue.set(res, 'types', ['*'])
        Vue.set(res, 'names', [res.register.registerName, res.short_name])

        that.$store.commit('setSelectedObject', res)
        that.$store.commit('setRegisterObject', true)
        that.$emit('emmitted', res)
        that.$emit('input', res)
        that.resetSearch()
        this.searchLoader = false
      }).catch(err => {
        this.searchLoader = false
        console.log(err)
      })
    },
    resetSearch: function () {
      this.searchText = ''
    },
    refresh: _.debounce(function () {
      var that = this
      let str = that.searchText
      str = str.toUpperCase()
      str = str.replace(/\s+/g, '')
      if (this.lastQuery === str) {
        return
      }
      this.lastQuery = str
      swh.querySkySources(str, 10).then(results => {
        if (str !== that.lastQuery) {
          console.log('Cancelled query: ' + str)
          return
        }
        that.autoCompleteChoices = results
      }, err => {
        console.log(err)
      })
    }, 200),
    nameForSkySource: function (s) {
      const cn = swh.cleanupOneSkySourceName(s.match)
      const n = swh.nameForSkySource(s)
      if (cn === n) {
        return n
      } else {
        return cn + ' (' + n + ')'
      }
    },
    typeToName: function (t) {
      return swh.nameForSkySourceType(t)
    },
    iconForSkySource: function (s) {
      return swh.iconForSkySource(s)
    }
  },
  mounted: function () {
    var that = this
    const onClick = e => {
      if (that.searchText !== '') {
        that.searchText = ''
      }
    }
    const guiParent = document.querySelector('stel') || document.body
    guiParent.addEventListener('click', onClick, false)
  },
  directives: {
    vClickOutside
  }
}
</script>

<style>

</style>
